
import React, { useState } from 'react'
import { useLanguage } from '../contexts/LanguageContext'  // Fixed import path
import styles from './SettingsPage.module.css'
import getData from './Model'

function SettingsPage() {
    const { language, changeLanguage } = useLanguage()
    const [selectedLanguage, setSelectedLanguage] = useState(language)
    const [message, setMessage] = useState('')
    
    const ui = getData('ui', language)  // Get UI translations

    const handleLanguageChange = (e) => {
        setSelectedLanguage(e.target.value)
    }

    const handleSave = () => {
        changeLanguage(selectedLanguage)
        const savedText = language === 'eng' 
            ? 'Settings saved successfully!' 
            : 'Настройки успешно сохранены!'
        setMessage(savedText)
        
        // Clear message after 3 seconds
        setTimeout(() => {
            setMessage('')
        }, 3000)
    }

    return (
        <div className={styles.settingsContainer}>
            <h2 className={styles.title}>{ui.settings}</h2>
            
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>{ui.language}</h3>
                
                <div className={styles.radioGroup}>
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            name="language"
                            value="eng"
                            checked={selectedLanguage === 'eng'}
                            onChange={handleLanguageChange}
                            className={styles.radioInput}
                        />
                        <span className={styles.radioText}>English</span>
                    </label>
                    
                    <label className={styles.radioLabel}>
                        <input
                            type="radio"
                            name="language"
                            value="rus"
                            checked={selectedLanguage === 'rus'}
                            onChange={handleLanguageChange}
                            className={styles.radioInput}
                        />
                        <span className={styles.radioText}>Русский (Russian)</span>
                    </label>
                </div>
            </div>
            
            <button 
                className={styles.saveButton}
                onClick={handleSave}
            >
                {ui.save}
            </button>
            
            {message && (
                <div className={styles.message}>
                    {message}
                </div>
            )}
        </div>
    )
}

export default SettingsPage